<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
// import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";

import { salesAnalyticsDonutChart, ChatData } from "./data";

/**
 * Saas Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    // PageHeader,
  },
  data() {
    return {
      usuario: this.$store.state.authfack.user,
      salesAnalyticsDonutChart: salesAnalyticsDonutChart,
      ChatData: ChatData,
      title: "Dashboards",
      items: [
        {
          text: "Dashboards",
          // href: "/",
        },
        {
          text: "Inicio rápido",
          active: true,
        },
      ],
      submitted: false,
      chat: {
        message: "",
      },
    };
  },
  validations: {
    chat: {
      message: {
        required,
      },
    },
  },
  methods: {
    /**
     * Char form Submit
     */
    // eslint-disable-next-line no-unused-vars
    formSubmit(e) {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const id = this.ChatData.length;
        const message = this.chat.message;
        const currentDate = new Date();
        this.ChatData.push({
          id: id + 1,
          align: "right",
          name: "Henry Wells",
          message,
          time: currentDate.getHours() + ":" + currentDate.getMinutes(),
        });
        this.handleScroll();
      }
      this.submitted = false;
      this.chat = {};
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },
  },
  mounted() {
    this.usuario = this.$store.state.authfack.user;
    /*   var container2 = document.querySelector(
      "#containerElement .simplebar-content-wrapper"
    );
    container2.scrollTo({ top: 500, behavior: "smooth" }); */
  },
};
</script>
<template>
  <Layout>
    <div class="welcome-container" v-if="usuario.role == 4 || usuario.role==1">
      <div class="content-section">
        <h1 class="welcome-title">Bienvenido A Granja El Bosque</h1>
        <div class="card-container">
          <router-link :to="{ name: 'concentrado' }" class="card-link">
            <div class="elegant-card inventory">
              <i class="icon fas fa-boxes"></i>
              <h3>Gestionar Concentrado</h3>
              <!-- <p></p> -->
            </div>
          </router-link>
          <router-link :to="{ name: 'concentrado' }" class="card-link">
            <div class="elegant-card inventory">
              <i class="icon bx bx-first-aid"></i>
              <h3>Gestionar Medicina</h3>
              <!-- <p></p> -->
            </div>
          </router-link>
          <router-link :to="{ name: 'concentrado' }" class="card-link">
            <div class="elegant-card inventory">
              <i class="icon bx bx-cart"></i>
              <h3>Compra productos</h3>
              <p></p>
            </div>
          </router-link>
          <router-link :to="{ name: 'compras_medicina' }" class="card-link">
            <div class="elegant-card inventory">
              <i class="icon bx bx-first-aid"></i>
              <h3>Compra Medicina</h3>
              <p></p>
            </div>
          </router-link>
          <router-link :to="{ name: 'cerdos' }" class="card-link">
          <div class="elegant-card pigs">
            <i class="icon fas fa-piggy-bank"></i>
            <h3>Cerdos</h3>
            <!-- <p>Cerdos</p> -->
          </div>
        </router-link>

          <router-link :to="{ name: 'lotes' }" class="card-link">
            <div class="elegant-card corrals">
              <i class="icon bx bx-home"></i>
              <h3>Gestionar Corrales</h3>
              <p></p>
            </div>
          </router-link>
          <router-link :to="{ name: 'asignacion_corrales' }" class="card-link">
            <div class="elegant-card assign-corrals">
              <i class="icon bx bx-transfer"></i>
              <h3>Asignación de Corrales</h3>
              <!-- <p></p> -->
            </div>
          </router-link>
          <router-link :to="{ name: 'inseminacion' }" class="card-link">
            <div class="elegant-card insemination">
              <i class="icon bx bx-droplet"></i>
              <h3>Gestionar Gestacion</h3>
              <p></p>
            </div>
          </router-link>
          <router-link :to="{ name: 'traslado' }" class="card-link">
            <div class="elegant-card transfer-birth">
            <i class="icon bx bx-right-arrow"></i>
            <h3>Traslado de Lactancia</h3>
            </div>
          </router-link>
          <router-link :to="{ name: 'AsignacionAlimento' }" class="card-link">
            <div class="elegant-card food-scheduling">
              <i class="icon bx bx-food-menu"></i>
              <h3>Programación de Alimento</h3>
            </div>

          </router-link>
          <router-link :to="{ name: 'listado_lotes_alimento' }" class="card-link">
            <div class="elegant-card feed-animals">
              <i class="icon bx bx-bowl-hot"></i>
              <h3>Echar Comida</h3>
            </div>

          </router-link>
          
        </div>
      </div>
    </div>
  </Layout>
</template>



<style scoped>

.welcome-container {
  min-height: 100vh;
  background:   linear-gradient(to bottom, 
    rgba(220, 225, 235, 0.6) 0%, 
    rgba(228, 233, 240, 0.6) 70%, 
    rgba(228, 233, 240, 0.4) 100%),
  url('~@/assets/images/profile-img.png') no-repeat center center; /* Ajuste en la posición de la imagen */
  background-size: cover; /* Asegura que la imagen cubra todo el contenedor */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 3rem;
  color: #333;
  filter: contrast(1.1) brightness(1.05);
}


.content-section {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.welcome-title {
  font-family: 'Playfair Display', serif;
  font-size: 3rem;
  margin-bottom: 3rem;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.7); /* Fondo blanco con opacidad */
  padding: 0.5rem 1rem; /* Espacio alrededor del texto */
  border-radius: 10px; /* Bordes redondeados para mantener un estilo elegante */
}


.card-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.elegant-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
}

.elegant-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 24px rgba(0, 0, 0, 0.2);
}

.icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  color: #444;
}

h3 {
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
}

p {
  font-size: 1rem;
  opacity: 0.8;
}

.card-link {
  text-decoration: none;
  color: inherit;
}

/* Responsive Design */
@media (min-width: 768px) {
  .welcome-title {
    font-size: 4rem;
  }
}

@media (max-width: 767px) {
  .card-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

@media (min-width: 1200px) {
  .welcome-container {
    padding: 5rem;
  }

  .card-container {
    gap: 3rem;
  }
}

</style>